<template>
  <div class="add-step">
    <div class="bg-black add-accont-header">
      <div class="add-brd">
        <div class="h-back" @click="goBackHandler">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </div>
        <h2>تنظیمات حساب</h2>
        <p>مرحله بعد: تایید بانکی</p>
      </div>
      <div>
        <svg class="header-progresbar">
          <circle class="meter" cx="57" cy="57" r="42" />
          <circle class="meter-2" cx="57" cy="57" r="42" />
          <text class="SVG-text" x="37" y="47">مرحله</text>
          <text x="65" y="74" class="SVG-text">3</text>
          <text x="50" y="74" class="SVG-text">از</text>
          <text x="37" y="74" class="SVG-text">4</text>
        </svg>
      </div>
    </div>
    <div class="add-card">
      <p class="head-step2">:محدودیت های مربوط به حساب</p>
      <div class="tPolicy">
        <div class="policyTitle">حداکثر تعداد برداشت روزانه</div>
        <div class="policyValue">
          {{ model.max_daily_transaction_count }}
        </div>
      </div>
      <div class="tPolicy">
        <div class="policyTitle">حداکثر تعداد برداشت ماهانه</div>
        <div class="policyValue">
          {{ model.max_monthly_transaction_count }}
        </div>
      </div>
      <div class="tPolicy">
        <div class="policyTitle">حداکثر برداشت در هر تراکنش(ریال)</div>
        <div class="policyValue">
          {{ formatPrice(model.transaction_max) }}
        </div>
      </div>
      <div class="t-main">
        <p>حساب پیش فرض</p>
        <input
          v-model="mainAcc"
          @change="mainAccChenge"
          type="checkbox"
          id="switch"
        /><label for="switch"></label>
      </div>
      <button class="m-btn add-confer-btn" @click="goNextHandler">تایید</button>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.getSetting();
  },
  data() {
    return {
      creatModel: {},
      mainAcc: false,
      model: {
        max_daily_transaction_count: 0,
        max_monthly_transaction_count: 0,
        ax_transaction_amount: 0,
        transaction_max: 5000,
        transaction_min: 0,
      },
    };
  },
  methods: {
    getSetting() {
      this.$store
        .dispatch("transaction/getPolicy")
        .then((rsp) => [(this.model = rsp)]);
    },
    mainAccChenge() {
      this.creatModel = this.$store.state.accounts.model;
      this.creatModel.is_default = this.mainAcc;
      this.$store.commit("accounts/setModel", this.creatModel);
    },

    formatPrice(value) {
      let val = (value / 1).toFixed(0).replace(".", ",");
      return val.toLocaleString("fa-IR").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    goNextHandler() {
      this.$emit("next");
    },
    goBackHandler() {
      this.$router.back();
    },
  },
};
</script>

<style scoped>
.head-step2 {
  margin-top: 50px;
  font-size: 20px;
}
.policyValue {
  font-weight: 1000;
  font-family: fd-v;
}
.policyTitle {
}
.t-main {
  display: flex;
  justify-content: space-between;
  flex-direction: row-reverse;
}
.tPolicy {
  background: #ddd;
  margin-bottom: 46px;
  margin-top: 40px;
  border-radius: 50px;
  font: 15px vazir;
  padding: 0 15px;
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
}
</style>
